import {  ADD_CATEGORY_RED, DELETE_CATEGORY_RED, GET_CATEGORY_RED, UPDATE_CATEGORY_RED } from "../Constant";
const initialState = [];
export function CategoryReducer(state = initialState, action){
    var newState
    switch (action.type) {
        case ADD_CATEGORY_RED:      
           return [...state, action.data];
        case GET_CATEGORY_RED:
            return action.data
        case DELETE_CATEGORY_RED:
            newState = state.filter(item=>item._id!==action.data._id)
            return newState
        case UPDATE_CATEGORY_RED:
            newState = state
            var index = newState.findIndex((item)=>item._id===(action.data._id))
            newState[index] = action.data
            return newState
        default:
            return state
    }
}